import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

export const api = {
  // Public
  getProjects: () => axios.get(`${API}/projects`),
  getProject: (id) => axios.get(`${API}/projects/${id}`),
  createLead: (data) => axios.post(`${API}/leads`, data),
  sendChat: (data) => axios.post(`${API}/chat`, data),

  // Admin
  adminLogin: (data) => axios.post(`${API}/admin/login`, data),
  getLeads: (token) => axios.get(`${API}/admin/leads`, { headers: { Authorization: `Bearer ${token}` } }),
  updateLead: (id, data, token) => axios.patch(`${API}/admin/leads/${id}`, data, { headers: { Authorization: `Bearer ${token}` } }),
  deleteLead: (id, token) => axios.delete(`${API}/admin/leads/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
  getStats: (token) => axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } }),
  getConversations: (token) => axios.get(`${API}/admin/conversations`, { headers: { Authorization: `Bearer ${token}` } }),
  getConversationMessages: (sessionId, token) => axios.get(`${API}/admin/conversations/${sessionId}`, { headers: { Authorization: `Bearer ${token}` } }),

  // Admin - Projects
  createProject: (data, token) => axios.post(`${API}/admin/projects`, data, { headers: { Authorization: `Bearer ${token}` } }),
  updateProject: (id, data, token) => axios.put(`${API}/admin/projects/${id}`, data, { headers: { Authorization: `Bearer ${token}` } }),
  deleteProject: (id, token) => axios.delete(`${API}/admin/projects/${id}`, { headers: { Authorization: `Bearer ${token}` } }),

  // Public - Clients
  getClients: () => axios.get(`${API}/clients`),

  // Admin - Clients
  createClient: (data, token) => axios.post(`${API}/admin/clients`, data, { headers: { Authorization: `Bearer ${token}` } }),
  deleteClient: (id, token) => axios.delete(`${API}/admin/clients/${id}`, { headers: { Authorization: `Bearer ${token}` } }),

  // Settings
  getSettings: () => axios.get(`${API}/settings`),
  updateSettings: (data, token) => axios.put(`${API}/admin/settings`, data, { headers: { Authorization: `Bearer ${token}` } }),

  // Carousel
  getCarousel: () => axios.get(`${API}/carousel`),
  getAdminCarousel: (token) => axios.get(`${API}/admin/carousel`, { headers: { Authorization: `Bearer ${token}` } }),
  createCarouselSlide: (data, token) => axios.post(`${API}/admin/carousel`, data, { headers: { Authorization: `Bearer ${token}` } }),
  updateCarouselSlide: (id, data, token) => axios.put(`${API}/admin/carousel/${id}`, data, { headers: { Authorization: `Bearer ${token}` } }),
  deleteCarouselSlide: (id, token) => axios.delete(`${API}/admin/carousel/${id}`, { headers: { Authorization: `Bearer ${token}` } }),

  // File Upload
  uploadFile: (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/upload`, formData, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
    });
  },
};
